const initialState = {
    emptyFilters: [],
    emptyParams: false
}

export default (state = initialState, action) => {
    let emptyFilters = [];
    switch(action.type){
        case 'ERROR_SET_EMPTY_FILTERS':
            return {...state, emptyFilters: action.payload}
        case 'SET_QUERY_VALUES':
            if(action.payload.values.length > 0){
                emptyFilters = state.emptyFilters.filter(f => f !== action.payload.code)
                return {...state, emptyFilters}
            }
            return state;
        case 'SET_QUERY_ALL_VALUES':
            emptyFilters = state.emptyFilters.filter(f => f !== action.payload)
            return {...state, emptyFilters}
        case 'ERROR_SET_EMPTY_PARAMS':
            return {...state, emptyParams: action.payload};
        default: return state;
    }
    
     
}